import * as React from 'react';
import { connect } from 'react-redux';

import IState from '../../interfaces/states';

import { Tag, Widget } from '../../store/models';

import {
    Widget as WidgetActions,
    WidgetEditor as WidgetEditorActions,
    SaveState as SaveStateActions,
} from '../../actions';
import WidgetEditor from './WidgetEditor';

interface IProps {
    widget: Widget,
    isOpen: boolean,
    tags: Tag[],
    save: Function,
    close: Function,
    setDirty: Function,
}

function onSave(widgetId: string, settings, props: IProps) {
    props.save(widgetId, settings);
    props.setDirty();
}

function onClose(props: IProps) {
    props.close();
}

const WidgetEditorContainer: React.StatelessComponent<IProps> = (props: IProps) => {
    const { widget, tags, isOpen } = props;

    const data = {
        tags
    };

    return (
        <WidgetEditor
            widget={widget}
            data={data}
            isOpen={isOpen}
            onSave={(widgetId: string, settings) => onSave(widgetId, settings, props)}
            onClose={() => onClose(props)}
        />
    );
}

WidgetEditorContainer.propTypes = {
    widget: React.PropTypes.object,
    isOpen: React.PropTypes.bool,
    tags: React.PropTypes.array.isRequired,
    save: React.PropTypes.func.isRequired,
    close: React.PropTypes.func.isRequired,
    setDirty: React.PropTypes.func.isRequired,
};

const mapStateToProps = (state: IState) => {
    return {
        widget: state.reportTemplate.byId[state.widgetEditor.widgetId],
        tags: state.tags.arr.map(tId => {
            return state.tags.byId[tId];
        }),
        isOpen: state.widgetEditor.open || false
    };
};

export default connect(
    mapStateToProps,
    {
        close: WidgetEditorActions.close,
        save: WidgetActions.updateWidgetSettings,
        setDirty: SaveStateActions.dirty,
    }
)(WidgetEditorContainer);


// WEBPACK FOOTER //
// ./src/components/widgetEditor/WidgetEditorContainer.tsx